import React from 'react';
import { Settings, Activity, Crown, Monitor } from '../utils/icons';

interface NavbarProps {
  systemHealth?: any;
}

const Navbar: React.FC<NavbarProps> = ({ systemHealth }) => {
  return (
    <nav
      className="gradient-bg shadow-lg border-b border-white/20 animate-fade-in-down"
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo and Title */}
          <div className="flex items-center space-x-3">
            <div className="relative">
              <Crown className="h-8 w-8 text-white" />
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full animate-pulse"></div>
            </div>
            <div>
              <h1 className="text-xl font-bold text-white">Universal Crown Prime</h1>
              <p className="text-xs text-white/80">Intelligent Project Setup</p>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-6">
            <NavLink href="/" icon={<Monitor className="w-4 h-4" />} text="Dashboard" />
            <NavLink href="/analyze" icon={<Activity className="w-4 h-4" />} text="Analyze" />
            <NavLink href="/recommendations" icon={<Crown className="w-4 h-4" />} text="Recommendations" />
            <NavLink href="/settings" icon={<Settings className="w-4 h-4" />} text="Settings" />
          </div>

          {/* System Status */}
          <div className="flex items-center space-x-3">
            {systemHealth && (
              <div className="flex items-center space-x-2">
                <div className={`w-2 h-2 rounded-full ${
                  systemHealth.status === 'healthy' ? 'bg-green-400' : 'bg-red-400'
                } animate-pulse`}></div>
                <span className="text-sm text-white/90">
                  {systemHealth.status === 'healthy' ? 'Online' : 'Offline'}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

interface NavLinkProps {
  href: string;
  icon: React.ReactNode;
  text: string;
}

const NavLink: React.FC<NavLinkProps> = ({ href, icon, text }) => {
  const prefetch = () => {
    // Prefetch chunks on intent
    if (href === '/analyze') import('../components/ProjectAnalyzerEnhanced');
    if (href === '/recommendations') import('../components/Recommendations');
    if (href === '/settings') import('../components/Settings');
    if (href === '/') import('../components/DashboardEnhanced');
  };
  return (
    <a
      href={href}
      onMouseEnter={prefetch}
      onFocus={prefetch}
      className="flex items-center space-x-2 text-white/90 hover:text-white transition-colors duration-200 px-3 py-2 rounded-lg hover:bg-white/10"
    >
      {icon}
      <span className="text-sm font-medium">{text}</span>
    </a>
  );
};

export default Navbar;
